import React from 'react';
import './Topbar.css';
import { schoolInfo } from '../data/schoolData';

export default function Topbar() {
  return (
    <div className="topbar">
      <span>📍 {schoolInfo.address}, {schoolInfo.district}, {schoolInfo.state}</span>
      <div className="topbar-right">
        <span>DISE: {schoolInfo.dise}</span>
        <a href={`mailto:${schoolInfo.email}`}>✉ {schoolInfo.email}</a>
      </div>
    </div>
  );
}
